export const EVENT_SOURCE_WINDOW = "window";

export const EVENT_SOURCE_VIEW = "view";

export const BROWSER = "browser";

export const NO_TRAP = {
    trap: !1
};

export const SIGNAL_WIDTH = "width";

export const SIGNAL_HEIGHT = "height";

export const SIGNAL_VIEW_WIDTH = "viewWidth";

export const SIGNAL_VIEW_HEIGHT = "viewHeight";

export const SIGNAL_PADDING = "padding";

export const SIGNAL_VIEW_BOX = "viewBox";

export const SIGNAL_AUTOFIT = "autoFit";

export const DEFAULT_HOVER_STATE = "hover";
//# sourceMappingURL=constants.js.map
